import axios from 'axios';
import Environment from '../../utils/Environment';
import { unwrapResponse } from './apiResponse';

export interface Group {
    groupId: string;
    groupNm: string;
    dstCntrCd: string;
    description: string;
    members?: string[];
}

export interface GroupPayload {
    groupId: string;
    groupNm: string;
    dstCntrCd: string;
    description: string;
    createUserId: string;
    members?: string[];
}

export const listGroups = async (): Promise<Group[]> => {
    const baseURL = Environment.getHubGroupsAPI();
    const response = await axios.get(baseURL);
    return unwrapResponse<Group[]>(response.data);
};

export const getGroup = async (id: string): Promise<Group> => {
    const baseURL = Environment.getHubGroupsAPI();
    const response = await axios.get(`${baseURL}/${encodeURIComponent(id)}`);
    return unwrapResponse<Group>(response.data);
};

export const listGroupsByDC = async (dc: string): Promise<Group[]> => {
    const baseURL = Environment.getHubGroupListAPI();
    const response = await axios.get(`${baseURL}/${encodeURIComponent(dc)}`);
    return unwrapResponse<Group[]>(response.data);
};

export const createGroup = async (payload: GroupPayload): Promise<Group> => {
    const baseURL = Environment.getHubGroupsAPI();
    const response = await axios.post(baseURL, payload);
    return unwrapResponse<Group>(response.data);
};

export const updateGroup = async (id: string, payload: GroupPayload): Promise<Group> => {
    const baseURL = Environment.getHubGroupsAPI();
    const response = await axios.post(`${baseURL}/${encodeURIComponent(id)}/update`, payload);
    return unwrapResponse<Group>(response.data);
};

export const deleteGroup = async (id: string): Promise<void> => {
    const baseURL = Environment.getHubGroupsAPI();
    await axios.post(`${baseURL}/${encodeURIComponent(id)}/delete`);
};

